import { GetAdminUserResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminUserService {
    public async getAdminUser(userId: string): Promise<GetAdminUserResult> {
        return api.admin.getUser(userId)
    }
}

export const service = new AdminUserService()